import { THEMES } from 'src/constants';

export const THEME_MODES = {
  LIGHT: 'light',
  DARK: 'dark',
};

export function getSystemPrefersDark() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return true;
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

/** Pick light/dark once from the device (used on first visit). */
export function themeModeFromDevice() {
  return getSystemPrefersDark() ? THEME_MODES.DARK : THEME_MODES.LIGHT;
}

/**
 * Resolve stored themeMode into an MUI theme name (LIGHT | ONE_DARK).
 */
export function resolveEffectiveTheme(themeMode) {
  if (themeMode === THEME_MODES.LIGHT) {
    return THEMES.LIGHT;
  }
  return THEMES.ONE_DARK;
}

/** Toggle only between light and dark. */
export function nextThemeMode(currentMode) {
  return currentMode === THEME_MODES.LIGHT
    ? THEME_MODES.DARK
    : THEME_MODES.LIGHT;
}

/**
 * Normalize settings to light|dark only.
 * First visit (or legacy "system") → follow device preference once, then persist.
 */
export function normalizeThemeSettings(settings = {}) {
  const next = { ...settings };

  if (next.themeMode === THEME_MODES.LIGHT || next.themeMode === THEME_MODES.DARK) {
    next.theme = resolveEffectiveTheme(next.themeMode);
    return next;
  }

  // Legacy: only `theme` was stored, or themeMode was "system"/missing.
  if (next.theme === THEMES.LIGHT) {
    next.themeMode = THEME_MODES.LIGHT;
  } else if (next.theme === THEMES.ONE_DARK || next.theme === THEMES.UNICORN) {
    next.themeMode = THEME_MODES.DARK;
  } else {
    next.themeMode = themeModeFromDevice();
  }

  next.theme = resolveEffectiveTheme(next.themeMode);
  return next;
}
